import { computed } from 'vue'

import { type UseClipboardOptions, useClipboard } from '@/composables/use-clipboard'
import { useAppStore } from '@/store/app-store'
import { useLoggerStore } from '@/store/logger'

export function useShareData(options: UseClipboardOptions = {}) {
    const appStore = useAppStore()
    const loggerStore = useLoggerStore()
    const { onSuccess, onError } = options
    const { copied, copyToClipboard } = useClipboard(options)
    const isDesktop = computed(() => appStore.platform === 'desktop')

    function logShare(source: string) {
        loggerStore.logEvent({
            event: 'custom_event',
            eventName: 'share',
            dimension1: source,
        })
    }

    const share = async (dataUrl: ShareData, source: string) => {
        if (!dataUrl) {
            return
        }

        if (!isDesktop.value && navigator.canShare && navigator.canShare(dataUrl)) {
            try {
                await navigator.share(dataUrl)
                logShare(source)
                onSuccess?.()
            } catch (error) {
                console.error('Failed to share link:', error)
                onError?.(error)
            }
        }

        copyToClipboard(dataUrl.url as string, () => logShare(source))
    }

    return {
        shared: copied,
        share,
    }
}
